import { FC } from "react";
import { Box, Button } from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import Markdown from "react-markdown";
import { Modal } from "components/Modal";
import { MarkdownStyleContainer } from "components/Container/MarkdownStyleContainer";
import { getRequirementTemplateDescription } from "../parseRequirementsCsv";
import { RequirementImportType } from "../types";

type Props = {
  open: boolean;
  requirementType: RequirementImportType;
  onClose: () => void;
  onDownloadTemplate: () => void;
};

export const CsvFormatInfoDialog: FC<Props> = ({
  open,
  requirementType,
  onClose,
  onDownloadTemplate,
}) => {
  return (
    <Modal
      title="CSV Format Required"
      open={open}
      onClose={onClose}
      size="medium"
    >
      <MarkdownStyleContainer>
        <Markdown>
          {getRequirementTemplateDescription(requirementType)}
        </Markdown>
      </MarkdownStyleContainer>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onDownloadTemplate}
          startIcon={<FileDownload />}
        >
          Download Template
        </Button>
      </Box>
    </Modal>
  );
};
